module.exports = __webpack_public_path__ + "img/40.1aad4a76.png";